/*
  CUSTOM CHANGE — neue Datei (komplett custom)
  Youmee.market — Such-Popup (Section ym-search-popup)
  Datei: assets/ym-search-popup.js   Erstellt: 2026-10-16 (#51)
  Update #59: Löschen-✕ an allen Suchfeldern, Such-Button + Platzhalter im Header,
  Link unten nennt den Suchbegriff.

  - Öffnet das Popup beim Klick/Fokus in ein Suchfeld:
      * Header-Suchfeld (Selektor aus den Section-Einstellungen)
      * jedes Feld mit data-ym-search-input (z. B. Seite "Alles entdecken")
  - Handy: Klick auf [data-search-mobile] (Lupe im Header) öffnet das Popup
    als Fenster mit eigenem Suchfeld (ersetzt Ellas Such-Seitenleiste).
  - Live-Treffer über /search/suggest + Section "ym-search-results".
  - Ohne JavaScript bleiben alle Suchfelder normale Formulare.
*/
(function () {
  'use strict';
  if (window.__ymSearchPopup) return;
  window.__ymSearchPopup = true;

  var MQ = window.matchMedia('(max-width: 749px)');
  var st = {
    pop: null, panel: null, results: null, all: null, sheetInput: null,
    input: null, mode: null, timer: null, ctrl: null, lastQ: '', cache: {},
    inputSel: '[data-ym-search-input]', mobileIcon: true, limit: 4
  };

  function mount() {
    var all = document.querySelectorAll('[data-ym-sp]');
    var fresh = null;
    for (var i = 0; i < all.length; i++) {
      if (!all[i].classList.contains('is-mounted')) fresh = all[i];
    }
    if (!fresh) return;
    for (var j = 0; j < all.length; j++) {
      if (all[j] !== fresh && all[j].classList.contains('is-mounted')) all[j].remove();
    }
    document.body.appendChild(fresh);
    fresh.classList.add('is-mounted');
    st.pop = fresh;
    st.panel = fresh.querySelector('.ym-sp__panel');
    st.results = fresh.querySelector('[data-ym-sp-results]');
    st.all = fresh.querySelector('[data-ym-sp-all]');
    st.sheetInput = fresh.querySelector('[data-ym-sp-input]');
    var hs = (fresh.getAttribute('data-header-selector') || '').trim();
    st.inputSel = '[data-ym-search-input]' + (hs ? ', ' + hs : '');
    st.mobileIcon = fresh.getAttribute('data-mobile-icon') === 'true';
    st.limit = parseInt(fresh.getAttribute('data-limit'), 10) || 4;
    st.cache = {}; st.lastQ = '';
    enhanceAll();
  }

  /* ---------- Suchfelder aufwerten: Löschen-✕, Such-Button im Header (#59) ---------- */
  var X_SVG = '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M7 7l10 10M17 7L7 17"></path></svg>';

  function enhance(input) {
    if (!input || input.getAttribute('data-ym-enh')) return;
    var form = input.closest('form');
    if (!form) return;
    input.setAttribute('data-ym-enh', '1');
    form.classList.add('ym-enh');
    var isHeader = !input.hasAttribute('data-ym-search-input');

    var clear = document.createElement('button');
    clear.type = 'button';
    clear.className = 'ym-clear';
    clear.setAttribute('aria-label', 'Suchbegriff löschen');
    clear.innerHTML = X_SVG;
    input.insertAdjacentElement('afterend', clear);

    if (isHeader) {
      form.classList.add('ym-hs');
      var ph = st.pop.getAttribute('data-header-placeholder');
      if (ph) input.setAttribute('placeholder', ph);
      var bg = st.pop.getAttribute('data-header-bg');
      if (bg) form.style.setProperty('--ym-hs-bg', bg);
      var go = document.createElement('button');
      go.type = 'submit';
      go.className = 'ym-go';
      go.textContent = st.pop.getAttribute('data-header-button') || 'Suchen';
      clear.insertAdjacentElement('afterend', go);
    }

    var sync = function () { form.classList.toggle('ym-has-value', !!input.value); };
    input.addEventListener('input', sync);
    sync();
    clear.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      input.value = '';
      sync();
      input.focus();
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }

  function enhanceAll() {
    var list;
    try { list = document.querySelectorAll(st.inputSel); } catch (e) { list = document.querySelectorAll('[data-ym-search-input]'); }
    for (var i = 0; i < list.length; i++) enhance(list[i]);
  }

  function isOpen() { return !!(st.pop && !st.pop.hidden); }

  function matchesInput(el) {
    if (!st.pop || !el || !el.matches || el === st.sheetInput) return false;
    try { return el.matches(st.inputSel); } catch (e) { return el.matches('[data-ym-search-input]'); }
  }

  function show() {
    st.pop.hidden = false;
    document.documentElement.classList.add('ym-sp-open');
    if (st.mode === 'sheet') document.documentElement.classList.add('ym-sp-lock');
    requestAnimationFrame(function () { st.pop.classList.add('is-visible'); });
  }

  function openAnchored(input) {
    if (st.input && st.input !== input && st.mode === 'anchor') st.input.setAttribute('aria-expanded', 'false');
    st.input = input;
    st.mode = 'anchor';
    st.pop.classList.remove('is-sheet');
    st.pop.classList.add('is-anchor');
    input.setAttribute('aria-expanded', 'true');
    input.setAttribute('aria-controls', 'ym-sp-panel');
    input.setAttribute('autocomplete', 'off');
    show();
    position();
    st.lastQ = null;
    schedule(true);
  }

  function openSheet() {
    st.mode = 'sheet';
    st.input = st.sheetInput;
    st.pop.classList.remove('is-anchor');
    st.pop.classList.add('is-sheet');
    st.panel.style.cssText = '';
    show();
    st.sheetInput.focus();
    st.lastQ = null;
    schedule(true);
  }

  function close() {
    if (!isOpen()) return;
    clearTimeout(st.timer);
    if (st.ctrl) st.ctrl.abort();
    st.pop.classList.remove('is-visible', 'is-loading');
    st.pop.hidden = true;
    document.documentElement.classList.remove('ym-sp-open', 'ym-sp-lock');
    if (st.input && st.mode === 'anchor') st.input.setAttribute('aria-expanded', 'false');
    st.mode = null;
  }

  function position() {
    if (!isOpen() || st.mode !== 'anchor' || !st.input) return;
    var box = st.input.closest('form') || st.input;
    var r = box.getBoundingClientRect();
    var vw = document.documentElement.clientWidth;
    var vh = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    var small = vw < 750;
    var margin = small ? 10 : 16;
    var w = small ? vw - margin * 2 : Math.min(Math.max(r.width, 440), 520, vw - margin * 2);
    var left = small ? margin : Math.min(Math.max(r.left, margin), vw - w - margin);
    var top = Math.max(r.bottom + 8, margin);
    var p = st.panel.style;
    p.left = left + 'px';
    p.top = top + 'px';
    p.width = w + 'px';
    p.maxHeight = Math.max(220, vh - top - margin) + 'px';
  }

  function currentQ() { return ((st.input && st.input.value) || '').trim(); }

  function schedule(now) {
    clearTimeout(st.timer);
    st.timer = setTimeout(run, now ? 0 : 220);
  }

  function updateAllLink(q) {
    var base = st.pop.getAttribute('data-search-url') || '/search';
    st.all.href = q ? base + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last' : base;
    var label = st.all.querySelector('span');
    if (label) {
      var tplQ = st.pop.getAttribute('data-all-label-q') || '';
      var plain = st.pop.getAttribute('data-all-label') || label.textContent;
      label.textContent = (q && tplQ.indexOf('%s') > -1) ? tplQ.replace('%s', q) : plain;
    }
  }

  function render(html) {
    st.pop.classList.remove('is-loading');
    st.results.innerHTML = html;
    st.pop.classList.add('has-query');
  }

  function run() {
    if (!st.pop) return;
    var q = currentQ();
    updateAllLink(q);
    if (q.length < 2) {
      if (st.ctrl) st.ctrl.abort();
      st.results.innerHTML = '';
      st.pop.classList.remove('has-query', 'is-loading');
      st.lastQ = '';
      return;
    }
    if (q === st.lastQ) return;
    st.lastQ = q;
    if (st.cache[q] !== undefined) { render(st.cache[q]); return; }
    if (st.ctrl) st.ctrl.abort();
    st.ctrl = window.AbortController ? new AbortController() : null;
    st.pop.classList.add('is-loading');
    var url = st.pop.getAttribute('data-suggest-url') +
      '?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection' +
      '&resources[limit]=' + st.limit +
      '&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,variants.title,vendor,tag' +
      '&section_id=ym-search-results';
    fetch(url, { signal: st.ctrl ? st.ctrl.signal : undefined, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.querySelector('[data-ym-sr]');
        var out = el ? el.innerHTML : '';
        st.cache[q] = out;
        if (q === currentQ()) render(out);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        st.pop.classList.remove('is-loading');
        st.lastQ = '';
      });
  }

  function setQuery(term) {
    if (!st.input) return;
    st.input.value = term;
    st.input.focus();
    st.lastQ = null;
    schedule(true);
  }

  /* ---------- Ereignisse (einmal, delegiert) ---------- */
  document.addEventListener('focusin', function (e) {
    if (matchesInput(e.target)) openAnchored(e.target);
  });

  document.addEventListener('input', function (e) {
    if (!st.pop) return;
    if (e.target === st.sheetInput && st.mode === 'sheet') { schedule(); return; }
    if (matchesInput(e.target)) {
      /* Esc leert ein Suchfeld im Browser selbst – dann nicht wieder öffnen */
      if (!isOpen() && !e.target.value.trim()) return;
      if (!isOpen() || st.input !== e.target) openAnchored(e.target);
      else schedule();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'ArrowDown' && e.target === st.input) {
      var first = st.panel.querySelector('.ym-sp__scroll a');
      if (first) { e.preventDefault(); first.focus(); }
    }
  });

  document.addEventListener('pointerdown', function (e) {
    if (!isOpen() || st.mode !== 'anchor') return;
    if (st.panel.contains(e.target) || e.target === st.input) return;
    if (st.input && st.input.form && st.input.form.contains(e.target)) return; /* z. B. Löschen-✕ */
    close();
  });

  /* Tab aus Popup und Feld heraus → schliessen */
  document.addEventListener('focusout', function () {
    if (!isOpen() || st.mode !== 'anchor') return;
    setTimeout(function () {
      var a = document.activeElement;
      if (!isOpen() || !a || a === document.body) return;
      if (a !== st.input && !st.panel.contains(a) && !(st.input.form && st.input.form.contains(a))) close();
    }, 0);
  });

  /* Handy: Lupe im Header (vor Ellas eigenem Klick-Handler abfangen) */
  window.addEventListener('click', function (e) {
    if (!st.pop || !st.mobileIcon || !e.target.closest) return;
    var t = e.target.closest('[data-search-mobile]');
    if (!t) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    openSheet();
  }, true);

  document.addEventListener('click', function (e) {
    if (!st.pop || !e.target.closest) return;
    var term = e.target.closest('[data-ym-sp-term]');
    if (term && st.panel.contains(term)) {
      e.preventDefault();
      setQuery(term.getAttribute('data-ym-sp-term'));
      return;
    }
    var c = e.target.closest('[data-ym-sp-close]');
    if (c && st.pop.contains(c)) { e.preventDefault(); close(); }
  });

  window.addEventListener('resize', position);
  window.addEventListener('scroll', position, { passive: true });
  if (window.visualViewport) window.visualViewport.addEventListener('resize', position);
  if (MQ.addEventListener) MQ.addEventListener('change', function () { if (st.mode === 'anchor') position(); });

  /* Customizer: Section neu geladen */
  document.addEventListener('shopify:section:load', function () { close(); mount(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
})();
